import "./Gallery.module.css";
import Navigation from "@/reusable_sections/Header";
import ChineseTeaAsAState from "./sections/ChineseTeaAsAState";
import ONossoTatame from "./sections/ONossoTatame";
import QuestionsParentales from "./sections/QuestionsParentales";
import Contact from "./sections/Contact";
import SiteFooter from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <Navigation />
      <ChineseTeaAsAState />
      <ONossoTatame />
      <QuestionsParentales />
      <Contact />
      <SiteFooter />
    </div>;
}